//WIDGET LIST
export const mods = {
    card: 'tarot',
    wheel: 'wheel',
    rune: 'rune',
    scratch: 'scratch',
    qcm: 'qcm',
    reveal: 'reveal',
};

export const events = {
    tarot: 'tarot-card-selected',
    wheel: 'wheel-result',
    rune: 'rune-selected',
    scratch: 'scratch-selected',
    qcm: 'qcm-selected',
    reveal: 'reveal-selected',
};

export const reload = ['wheel', 'scratch', 'qcm', 'reveal']; // List of modules that can be reloaded between steps

export const disabled = {
    cta: 'cta',
    upload: 'upload',
    ...mods,
}; // list of types that won't be showed a second time
